<template>
  <div class="arrow-ball">
    <svg viewBox="0 0 80 80">
      <circle class="background" cx="40" cy="40" r="38" />
      <circle class="fill" cx="40" cy="40" r="38" />
      <g class="arrow-rotation">
        <g class="arrow" fill="none" stroke-width="1" vector-effect="non-scaling-stroke">
          <g class="arrow-animation" vector-effect="non-scaling-stroke">
            <path d="M10.4.701l9.899 9.9-9.9 9.899" vector-effect="non-scaling-stroke"/>
            <path d="M20.299 10.6H.5" stroke-linecap="square" vector-effect="non-scaling-stroke" />
          </g>
        </g>
        <rect width="80" height="80" x="0" y="0" fill="none" />
      </g>
    </svg>
  </div>
</template>

<script>
import { isMobile } from '../scripts/utils';

export default {
  name: 'ArrowBall',

  mounted() {
    this.$nextTick(() => {
      if (!isMobile()) {
        this.$el.style.setProperty('--len', this.$el.querySelector('.fill').getTotalLength());
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.arrow-ball {
  svg {
    circle {
      fill: none;
      stroke-width: 1px;
      stroke: $color-white;
      transform: scale(0.5);
      transform-origin: 50% 100%;

      @at-root .page-white & {
        stroke: $color-dark;
      }

      &.background {
        opacity: 0.6;
        transition: transform .3s $inOutCubic;
      }

      &.fill {
        stroke-dasharray: var(--len);
        stroke-dashoffset: var(--len);
        transition: transform .3s $inOutCubic,
                    stroke-dashoffset .3s $inOutCubic 0s;
      }
    }

    .arrow {
      transform: scale(1) translateX(30px) translateY(30px);
      opacity: 0;
      transition: opacity .3s $inOutCubic 0s;
      stroke: $color-white;

      @at-root .page-white & {
        stroke: $color-dark;
      }
    }

    .arrow-rotation {
      transform-origin: center center;
    }
  }
}
</style>
